// packages
import React from 'react';

// types
import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import { ResourceResponse } from 'generated/index';

// components
import DrawerFormSkeleton from 'components/shared/CRUD/components/DrawerFormSkeleton';
import { LoadingError } from 'components/shared/LoadingError/LoadingError';
import { ResourceForm } from '../ResourceForm/ResourceForm';

// utils
import { queries } from 'RestAPIs/rapini';

export const CreateResourceDrawer: React.FC<
  FormComponentProps<ResourceResponse>
> = ({ handleClose, rowId, rows = [] }) => {
  const { isFetching, data, error, refetch } = queries.useFindResourceById(
    rowId as string,
    {
      enabled: !!rowId
    }
  );

  return isFetching ? (
    <DrawerFormSkeleton count={3} />
  ) : error ? (
    <LoadingError reFetch={refetch} />
  ) : (
    <ResourceForm handleClose={handleClose} rowData={data} rows={rows} />
  );
};
